var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Evaluaciones enviadas")]),_c('EvaluationAttemptsList',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }